export default __webpack_public_path__ + "static/media/gnd_kr_alph_a2.84680749.mp3";